/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import { GiftOutlined, NotificationBar, useBreakpoint } from '@landr/maestro';
import { PrismicHTML } from 'components/Prismic';
import { UniversalNavigationReferralData } from 'components/UniversalNavigation';
import './ReferralsBanner.scss';

export interface ReferralsBannerProps {
    data: UniversalNavigationReferralData;
}

export const ReferralsBanner: React.FC<ReferralsBannerProps> = ({ data }) => {
    const isMobile = useBreakpoint('sm');
    const pageParams = new URLSearchParams(window.location.search);
    const hasReferralUtm = pageParams.get('utm_campaign') === 'sales_platform_en_intl_1stpromoter';

    if (!hasReferralUtm || !data || !data.referral_label_desktop || !data.referral_label_mobile) {
        return null;
    }
    return (
        <NotificationBar variant="informational" icon={GiftOutlined}>
            <PrismicHTML
                className="Referrals-text"
                content={isMobile ? data.referral_label_mobile : data.referral_label_desktop}
            />
        </NotificationBar>
    );
};
